import React from 'react';

import { SkeletonLoader } from 'common/react/components/SkeletonLoader';

/**
 * Displays a loading state for the Team Lineups Condensed CTA.
 *
 * @returns The Team Lineups Condensed CTA skeleton loader.
 */

const PLAYER_WIDTH_DESKTOP = 140;
const PLAYER_WIDTH_MOBILE = 100;

const typeToggle = (
    <div className="team-lineups__sub-section">
        <SkeletonLoader
            width={300}
            height={32}
            className={'team-lineups__tabs'}
        />
    </div>
);

const flexColumnDesktop = (
    <div className="team-lineups__position-group flex-column">
        <SkeletonLoader width={PLAYER_WIDTH_DESKTOP} height={32} />
        <SkeletonLoader width={PLAYER_WIDTH_DESKTOP} height={32} />
    </div>
);

const teamZoneDesktop = (
    <div className="team-lineups__team-zone flex-row flex-row--nowrap">
        <SkeletonLoader
            width={32}
            height={32}
            className="team-lineups__team-zone-position"
        />
        <SkeletonLoader width={PLAYER_WIDTH_DESKTOP} height={32} />
        <SkeletonLoader width={PLAYER_WIDTH_DESKTOP} height={32} />
        <SkeletonLoader width={PLAYER_WIDTH_DESKTOP} height={32} />
    </div>
);

const teamZoneMobile = (
    <div className="team-lineups__team-zone flex-row flex-row--nowrap">
        <SkeletonLoader
            width={32}
            height={32}
            className="team-lineups__team-zone-position"
        />
        <SkeletonLoader width={PLAYER_WIDTH_MOBILE} height={32} />
        <SkeletonLoader width={PLAYER_WIDTH_MOBILE} height={32} />
        <SkeletonLoader width={PLAYER_WIDTH_MOBILE} height={32} />
    </div>
);

const header = (
    <div className="team-lineups__title-section">
        <SkeletonLoader width={120} height={20} />
    </div>
);

const insOuts = (
    <div className="team-lineups-ins-and-outs">
        <div className="team-lineups__grid">
            <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--home">
                <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                    <div className="team-lineups-ins-and-outs__grid-item">
                        <SkeletonLoader width={90} height={20} />
                        <SkeletonLoader
                            width={48}
                            height={48}
                            className="team-lineups-ins-and-outs__headshot"
                        />
                    </div>
                </div>
                <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                    <div className="team-lineups-ins-and-outs__grid-item">
                        <SkeletonLoader width={90} height={20} />
                        <SkeletonLoader
                            width={48}
                            height={48}
                            className="team-lineups-ins-and-outs__headshot"
                        />
                    </div>
                </div>
            </div>
            <div className="team-lineups__title-section">
                <SkeletonLoader
                    width={56}
                    height={24}
                    className="team-lineups-ins-and-outs__title-wrapper"
                />
            </div>
            <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--away">
                <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                    <div className="team-lineups-ins-and-outs__grid-item">
                        <SkeletonLoader width={90} height={20} />
                        <SkeletonLoader
                            width={48}
                            height={48}
                            className="team-lineups-ins-and-outs__headshot"
                        />
                    </div>
                </div>
                <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                    <div className="team-lineups-ins-and-outs__grid-item">
                        <SkeletonLoader width={90} height={20} />
                        <SkeletonLoader
                            width={48}
                            height={48}
                            className="team-lineups-ins-and-outs__headshot"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const milestonesChangesDesktop = (
    <div className="team-lineups__grid mc-team-lineups__row">
        <div className="team-lineups__event-text team-lineups__event-text--home">
            <SkeletonLoader width={250} height={20} />
        </div>
        <div className="team-lineups__title-section">
            <SkeletonLoader width={120} height={20} />
        </div>
        <div className="team-lineups__event-text team-lineups__event-text--away">
            <SkeletonLoader width={250} height={20} />
        </div>
    </div>
);

const milestonesChangesMobile = (
    <>
        {header}
        <div className="team-lineups__grid mc-team-lineups__row">
            <SkeletonLoader width={150} height={20} />
            <SkeletonLoader width={150} height={20} />
        </div>
    </>
);

const lastUpdatedDesktop = (
    <div className="team-lineups__last-updated">
        <SkeletonLoader width={14} height={14} />
        <SkeletonLoader width={300} height={20} />
    </div>
);

const legendDesktop = (
    <div className="legend legend--team-lineups">
        <div className="legend__list">
            <SkeletonLoader
                width={PLAYER_WIDTH_MOBILE}
                height={16}
                className="legend__item"
            />
            <SkeletonLoader
                width={PLAYER_WIDTH_MOBILE}
                height={16}
                className="legend__item"
            />
            <SkeletonLoader
                width={PLAYER_WIDTH_MOBILE}
                height={16}
                className="legend__item"
            />
            <SkeletonLoader
                width={PLAYER_WIDTH_MOBILE}
                height={16}
                className="legend__item"
            />
            <SkeletonLoader
                width={PLAYER_WIDTH_MOBILE}
                height={16}
                className="legend__item"
            />
        </div>
    </div>
);
export const MCTeamLineupsSkeletonLoader = () => (
    <>
        <div className="mc-team-lineups__skeleton">
            {typeToggle}
            <div className="mc-team-lineups__inner-wrapper">
                <div className="u-hide-until-tablet">
                    <div className="team-lineups__field-view">
                        <SkeletonLoader
                            width={300}
                            height={32}
                            className="toggle-input"
                        />
                        <div className="team-lineups__field">
                            <div className="team-lineups__field-column team-lineups__field-column--left flex-column">
                                <div className="team-lineups__positions-section flex-column team-lineups__positions-section--3-items">
                                    <SkeletonLoader
                                        width={75}
                                        height={36}
                                        className="team-lineups__field-column-header"
                                    />
                                </div>
                                <div className="team-lineups__positions-section">
                                    <div className="team-lineups__players-list">
                                        {flexColumnDesktop}
                                        {flexColumnDesktop}
                                        {flexColumnDesktop}
                                    </div>
                                </div>
                            </div>
                            <div className="team-lineups__field-column team-lineups__field-column--starters">
                                <div className="team-lineups__teams-labels flex-row flex-row--nowrap">
                                    <SkeletonLoader width={127} height={36} />
                                    <SkeletonLoader width={127} height={36} />
                                </div>
                                <div className="team-lineups__oval">
                                    <div className="team-lineups__starters-grid flex-column">
                                        <div className="team-lineups__oval-section flex-column">
                                            {teamZoneDesktop}
                                            {teamZoneDesktop}
                                        </div>
                                        <div className="team-lineups__oval-section flex-column">
                                            {teamZoneDesktop}
                                            {teamZoneDesktop}
                                        </div>
                                        <div className="team-lineups__oval-section flex-column">
                                            {teamZoneDesktop}
                                            {teamZoneDesktop}
                                        </div>
                                        <div className="team-lineups__oval-section flex-column">
                                            {teamZoneDesktop}
                                            {teamZoneDesktop}
                                        </div>
                                        <div className="team-lineups__oval-section flex-column">
                                            {teamZoneDesktop}
                                            {teamZoneDesktop}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="team-lineups__positions-section flex-column team-lineups__positions-section--4-items">
                                <SkeletonLoader
                                    width={75}
                                    height={36}
                                    className="team-lineups__field-column-header"
                                />
                                <div className="team-lineups__players-list">
                                    {flexColumnDesktop}
                                    {flexColumnDesktop}
                                    {flexColumnDesktop}
                                    {flexColumnDesktop}
                                </div>
                                <div className="team-lineups__positions-section flex-column team-lineups__positions-section--1-items">
                                    <SkeletonLoader
                                        width={75}
                                        height={36}
                                        className="team-lineups__field-column-header"
                                    />
                                    {flexColumnDesktop}
                                </div>
                            </div>
                        </div>
                    </div>
                    {insOuts}
                    {insOuts}
                    {insOuts}
                    {milestonesChangesDesktop}
                    {milestonesChangesDesktop}
                    {lastUpdatedDesktop}
                </div>

                <div className="u-hide-from-tablet">
                    <div className="team-lineups__sub-section">
                        <div className="team-lineups__field-view">
                            <SkeletonLoader
                                width={300}
                                height={32}
                                className="toggle-input"
                            />
                            <div className="team-lineups__teams-labels flex-row flex-row--nowrap">
                                <SkeletonLoader width={120} height={40} />
                                <SkeletonLoader width={120} height={40} />
                            </div>
                            <div className="team-lineups__oval">
                                <div className="team-lineups__starters-grid flex-column">
                                    <div className="team-lineups__oval-section flex-column">
                                        {teamZoneMobile}
                                        {teamZoneMobile}
                                    </div>
                                    <div className="team-lineups__oval-section flex-column">
                                        {teamZoneMobile}
                                        {teamZoneMobile}
                                    </div>
                                    <div className="team-lineups__oval-section flex-column">
                                        {teamZoneMobile}
                                        {teamZoneMobile}
                                    </div>
                                    <div className="team-lineups__oval-section flex-column">
                                        {teamZoneMobile}
                                        {teamZoneMobile}
                                    </div>
                                    <div className="team-lineups__oval-section flex-column">
                                        {teamZoneMobile}
                                        {teamZoneMobile}
                                    </div>
                                </div>
                            </div>
                            <div className="team-lineups__positions-section flex-column team-lineups__positions-section--3-items">
                                <div className="team-lineups__field-column-header">
                                    <SkeletonLoader
                                        width={PLAYER_WIDTH_MOBILE}
                                        height={32}
                                    />
                                </div>

                                <div className="team-lineups__players-list">
                                    <div className="team-lineups__position-group flex-column">
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                    </div>
                                    <div className="team-lineups__position-group flex-column">
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                    </div>
                                    <div className="team-lineups__position-group flex-column">
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="team-lineups__positions-section flex-column team-lineups__positions-section--4-items">
                                <div className="team-lineups__field-column-header">
                                    <SkeletonLoader
                                        width={PLAYER_WIDTH_MOBILE}
                                        height={32}
                                    />
                                </div>

                                <div className="team-lineups__players-list">
                                    <div className="team-lineups__position-group flex-column">
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                    </div>
                                    <div className="team-lineups__position-group flex-column">
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                    </div>
                                    <div className="team-lineups__position-group flex-column">
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                    </div>
                                    <div className="team-lineups__position-group flex-column">
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="team-lineups__positions-section flex-column team-lineups__positions-section--1-items">
                                <div className="team-lineups__field-column-header">
                                    <SkeletonLoader
                                        width={PLAYER_WIDTH_MOBILE}
                                        height={32}
                                    />
                                </div>

                                <div className="team-lineups__players-list">
                                    <div className="team-lineups__position-group flex-column">
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                        <SkeletonLoader
                                            width={PLAYER_WIDTH_MOBILE}
                                            height={32}
                                        />
                                    </div>
                                </div>
                            </div>
                            {header}
                            {insOuts}
                            {header}
                            {insOuts}
                            {header}
                            {insOuts}
                            {milestonesChangesMobile}
                            {milestonesChangesMobile}
                        </div>
                    </div>
                </div>
            </div>
            {legendDesktop}
        </div>
    </>
);
